<!-- Translated: skip -->
<template>
  <div class="background-blue-lift" style="position:relative;">
    <Timeline :steps="timelineSteps" theme="light"></Timeline>
<!--
Antal kvar: {{filtered.length}}
Steg: {{stage}}
-->
    <LanguageSwitcher type="dropdown" v-if="!$store.state.isOnSite" :show-title="false" @pickedlanguage="remount" />

    <div class="content center">

      <h1 v-if="$route.params.person === '0'">{{ $t('skirental.book-first-skier') }}</h1>
      <h1 v-if="$route.params.person !== '0'">{{ $t('skirental.book-skier-x', {number: parseInt($route.params.person) + 1}) }}</h1>

      <h1 v-if="$route.query.onlyseason === '1'">Säsongskort</h1>

    </div>

    <div :class="'content'">

      <h2 class="center">Välj typ av liftkort</h2>

      <div class="center skipass-age-wrapper">
        <div
          v-for="option in options"
          @click="setAge(option.value)"
          v-if="(!selectedAge || selectedAge === option.value)"
          :class="{
            button: true,
            underlined: true,
            'small-text': true,
            checked: (selectedAge === option.value),
            'has-description' : (option.subtitle)
            }"
          >
            {{option.title}}
            <span>{{option.subtitle}}</span>
        </div>

      </div>

    </div>

    <hr>

    <div :class="'content center ' + (selectedAge ? '' : 'disabled')">

      <div v-if="!$store.state.isOnSite">
        <h2 v-if="SITE_CONFIG.skipass.day_online && SITE_CONFIG.skipass.season_online">Antal dagar / säsongskort</h2>
        <h2 v-if="SITE_CONFIG.skipass.day_online && !SITE_CONFIG.skipass.season_online">Antal dagar</h2>
        <h2 v-if="!SITE_CONFIG.skipass.day_online && SITE_CONFIG.skipass.season_online">Välj Säsongskort</h2>
      </div>
      <div v-if="$store.state.isOnSite">
        <h2 v-if="SITE_CONFIG.skipass.day_onsite && SITE_CONFIG.skipass.season_onsite">Antal dagar / säsongskort</h2>
        <h2 v-if="SITE_CONFIG.skipass.day_onsite && !SITE_CONFIG.skipass.season_onsite">Antal dagar</h2>
        <h2 v-if="!SITE_CONFIG.skipass.day_onsite && SITE_CONFIG.skipass.season_onsite">Välj Säsongskort</h2>
      </div>

      <div class="blocked" v-if="!SITE_CONFIG.modules_open.skipass.open">
        <p style="color:white;">{{ SITE_CONFIG.modules_open.skipass.closed_message }}</p>
      </div>

      <div class="blocked" v-if="SITE_CONFIG.modules_open.skipass.open">

        <Dropdown
          prefixicon="calendar"
          prefixicon-validated="calendar-white"
          :options="days"
          :validated="selectedDays && selectedDays.value"
          :value="selectedDays"
          :label="(selectedDays && selectedDays.value) ? (selectedDays.title) : 'Välj liftkort'"
          :with-background="true"
          @changed="changedDate"
          :bold-label="true"
          @clicked-suffix="changedDate({})">
        </Dropdown>
      </div>

    </div>

    <hr v-if="selectedDays && selectedDays.value && selectedDays.value.indexOf('0') === 0">

    <div class="content">
      <div class="center" v-if="isSeason">
        <div class="inline-block min-width white-text" v-if="SITE_CONFIG.site === 'kungsberget'">
          <p><b>Information om säsongskort</b></p>
          <p>Vid köp av ett nytt säsongskort så hämtar du ut det på plats i Kungsbergets Infocenter och blir då fotograferad. Du kan också ladda ett Keycard som säsongskort via <a href="http://ladda.kungsberget.se/">ladda.kungsberget.se</a></p>
        </div>
        <div class="inline-block min-width white-text" v-if="SITE_CONFIG.site === 'branas'">
          <p><b>Information om säsongskort</b></p>
          <p>Vid köp av ett nytt säsongskort så hämtar du ut det på plats i Branäs Infocenter och blir då fotograferad. Du kan också ladda ett Keycard som säsongskort via <a href="http://ladda.branas.se/">ladda.branas.se</a></p>
        </div>
        <div class="inline-block min-width white-text" v-if="SITE_CONFIG.site === 'vallasen'">
          <p><b>Information om säsongskort</b></p>
          <p>Kampanjpriserna gäller fram till 14:e december.</p>
          <br>
          <p>Ta med bokningsnumret och visa i liftkortskassan första dagen du besöker oss (när vi har öppnat), du blir då fotograferad och får ditt nya säsongskort.</p>
          <!-- <p>Vid köp av ett nytt säsongskort senast den 1:a december så skickas kortet hem till dig, det är då laddat med en åkdag. Första dagen du besöker anläggningen (när vi har öppnat) ska du uppsöka Infocenter för att få ditt kort uppgraderat till ett säsongskort, alternativt bli fotograferad och få ett nytt kort. Samma sak gäller om du redan har ett Keycard som du laddar som säsongskort.</p> -->
          <!-- <br> -->
          <!-- <p>Vid köp av säsongskort online från 1:a december så skickas ej korten ut, utan du tar med ditt bokningsnummer och visar första dagen du besöker anläggningen (när vi har öppnat) och får då ditt säsongskort.</p> -->
        </div>
        <div class="inline-block min-width white-text" v-if="['ulricehamn', 'storstenshojden', 'tolvmannabacken'].indexOf(SITE_CONFIG.site) !== -1">
          <p><b>Information om säsongskort</b></p>
          <!--<p>Kampanjpriserna gäller fram till 9:e december.</p>-->
          <br>
          <p>Ta med bokningsnumret och visa i liftkortskassan första dagen du besöker oss (när vi har öppnat), du blir då fotograferad och får ditt nya säsongskort.</p>
          <!-- <p>Vid köp av ett nytt säsongskort senast den 1:a december så skickas kortet hem till dig, det är då laddat med en åkdag. Första dagen du besöker anläggningen (när vi har öppnat) ska du uppsöka Infocenter för att få ditt kort uppgraderat till ett säsongskort, alternativt bli fotograferad och få ett nytt kort. Samma sak gäller om du redan har ett Keycard som du laddar som säsongskort.</p> -->
          <!-- <br> -->
          <!-- <p>Vid köp av säsongskort online från 1:a december så skickas ej korten ut, utan du tar med ditt bokningsnummer och visar första dagen du besöker anläggningen (när vi har öppnat) och får då ditt säsongskort.</p> -->
        </div>
      </div>
    </div>

    <!-- <hr v-if="selectedDays.value && selectedDays.value.substr(2, 1) >= 4 && selectedDays.value.substr(2, 1) <= 6">

    <div class="content">
      <div class="center" v-if="selectedDays.value && selectedDays.value.substr(2, 1) >= 4 && selectedDays.value.substr(2, 1) <= 6">
        <div class="inline-block min-width white-text">
          <p><b>Information om premiärkort</b></p>
          <p>Premiärkorten gäller endast under premiärhelgen.</p>
        </div>
      </div>
    </div> -->

    <hr>

    <div :class="'content ' + ((selectedAge && selectedDays && selectedDays.value) ? '' : 'disabled')">

      <h2 class="center" @click="openModal(['SkipassInfo'])">
        <span v-if="SITE_CONFIG.skipass.load_enabled && !isSeason">
          Ladda ditt befintliga liftkort eller
        </span>
        köp
        <span v-if="isSeason">
          säsongskort och
        </span>
        keycard
        <icon name="info-white" :scale="1.4" style="margin-left:0.2em;cursor:pointer;" />
      </h2>

      <div class="center">
        <div
          v-for="(product, key) in products"
          @click="setType(key)"
          v-if="(!selectedType || selectedType === key) && ((key === 'load' && isSeason) ? false : true)"
          :class="{
            button: true,
            'small-text': true,
            wide: true,
            underlined: true,
            checked: (selectedType === key),
            'has-description' : (product.description)
            }"
            >
          {{product.title}}
          <span>{{product.description}}</span>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
import { mapMutations } from 'vuex';
import Dropdown from '@/components/components/Dropdown';
import Datepicker from '@/components/components/Datepicker';
import Timeline from '@/components/components/Timeline';
import {
  validStartDate,
} from '@/dates';

import skipassTimelineSteps from '@/mixins/skipassTimelineSteps';

import LanguageSwitcher from '@/components/components/LanguageSwitcher';

import API from '@/classes/API';

import moment from 'moment';

export default {
  components: {
    Dropdown,
    Datepicker,
    Timeline,
    LanguageSwitcher,
  },
  mixins: [skipassTimelineSteps],
  data() {
    return {
      name: '',
      selectedAge: '',
      selectedDays: {},
      stage: 10,
      selectedCategory: '',
      selectedSubCategory: '',
      selectedType: '',
      searchPackage: '',
      validatedName: false,
      refill: false,
      keycardNumber: '',
      keycardNumberPrefix: '',
      daysRemote: null,
      titles: {},
      keycard: null,
      keycardObject: null,
      daysOriginal: [],
      options: [{
        value: 'children',
        title: 'Barn',
        subtitle: '(0-6 år)',
      }, {
        value: 'youths',
        title: 'Ungdom',
        subtitle: '(7-17 år)',
      }, {
        value: 'adults',
        title: 'Vuxen',
        subtitle: '(18-64 år)',
      }, {
        value: 'seniors',
        title: 'Senior',
        subtitle: '(18+ år)',
      }],
      /* categories: {
        alpine: 'Alpin',
        snowboard: 'Snowboard',
        other: 'Annan utrustning',
      }, */
      categories_all: [],
      categories_main: [],
      categories_other: [],
      delivery: false,
      products: {
      },
      allProducts: [],
      asterisks: [],
    };
  },
  async mounted() {
    const years = this.$i18n.t('general.years'); // eslint-disable-line
    this.options[0].subtitle = `${this.SITE_CONFIG.skipass.ages.children} ${years}`;
    this.options[1].subtitle = `${this.SITE_CONFIG.skipass.ages.youths} ${years}`;
    this.options[2].subtitle = `${this.SITE_CONFIG.skipass.ages.adults} ${years}`;
    this.options[3].subtitle = `${this.SITE_CONFIG.skipass.ages.seniors} ${years}`;

    if (!this.SITE_CONFIG.skipass.ages.seniors) {
      this.options.splice(3, 1);
    }

    if (this.SITE_CONFIG.skipass.load_enabled) {
      this.products.load = {
        title: 'Ladda liftkort',
      };
    }

    if (this.SITE_CONFIG.skipass.buy_enabled ||
        (this.SITE_CONFIG.skipass.buy_enabled_when_accomodation_or_rental && (this.has('accomodations', true) || this.has('rentals', true))) ||
        (this.SITE_CONFIG.skipass.buy_enabled_when_accomodation_or_rental &&
          (this.$store.state.cart.addToOrder && this.$store.state.cart.addToOrder.number))
        ) {
      this.products.buy = {
        title: 'Köp nytt liftkort',
      };
    }

    if (this.SITE_CONFIG.skipass.parents_enabled) {
      this.options.push({
        value: 'parents',
        title: 'Föräldrakort',
        subtitle: 'Kan delas av föräldrar',
      });
    }

    this.remount();
  },
  computed: {
    isSeason() {
      if (this.selectedDays && this.selectedDays.value) {
        return (this.selectedDays.value.indexOf('7') === 2
          || this.selectedDays.value.indexOf('8') === 2
          || this.selectedDays.value.indexOf('9') === 2
          || this.selectedDays.value.indexOf('10') === 2
          || this.selectedDays.value.indexOf('11') === 2
          || this.selectedDays.value.indexOf('12') === 2
          || this.selectedDays.value.indexOf('13') === 2);
      }
      return false;
    },
    days() {
      const days = [];

      if (this.daysRemote) {
        const category = this.selectedAge;
        let age = {
          children: 'children',
          youths: 'youths',
          adults: 'adults',
          parents: 'parents',
          seniors: 'seniors',
        };
        age = age[category];

        if (typeof age === 'undefined') {
          return this.daysOriginal;
        }

        let i;

        /* eslint-disable */
        let seasonSeparator = false;
        let specialSeparator = false;
        let normalSeparator = false;
        let discountSeparator = false;
        let premiereSeparator = false;

        for (i in this.daysRemote) {
          let day = this.daysRemote[i][age];

          if (!day || !Number.isInteger(day.days)) {
            continue;
          }

          let title = this.titles[i];
          let asterisk = day.header_text;

          if (!title) {
            continue;
          }

          let price = Math.round(parseFloat(day.price));

          if (asterisk && !discountSeparator) {
            discountSeparator = true;
            days.push({
              title: (this.$route.query.onlyseason ? this.asterisks[1].text : this.asterisks[0].text),
              subtitle: '',
              price1: '',
              price: '',
              marked: false,
              separator: true,
              value: '',
              pool_lid: 0,
            });
          }

          if (day.is_season && !seasonSeparator) {
            seasonSeparator = true;
            days.push({
              title: 'Säsong',
              subtitle: '',
              price1: '',
              price: '',
              marked: false,
              separator: true,
              value: '',
              pool_lid: 0,
            });
          }

          if (day.is_premiere && !premiereSeparator) {
            premiereSeparator = true;
            days.push({
              title: 'Premiär',
              subtitle: '',
              price1: '',
              price: '',
              marked: false,
              separator: true,
              value: '',
              pool_lid: 0,
            });
          }

          if ((!day.variant && !normalSeparator && this.SITE_CONFIG.site === 'kungsberget') || (!day.variant && !specialSeparator && this.SITE_CONFIG.site === 'branas')) {
            if (this.SITE_CONFIG.site === 'kungsberget') {
              normalSeparator = true;
            }
            if (this.SITE_CONFIG.site === 'branas') {
              specialSeparator = true;
            }
            days.push({
              title: 'Dygn',
              subtitle: '',
              price1: '',
              price: '',
              marked: false,
              separator: true,
              value: '',
              pool_lid: 0,
            });
          }

          if (this.SITE_CONFIG.site === 'kungsberget' && day.variant && !day.is_premiere && !specialSeparator) {
            specialSeparator = true;
            days.push({
              title: 'Special',
              subtitle: '',
              price1: '',
              price: '',
              marked: false,
              separator: true,
              value: '',
              pool_lid: 0,
            });
          }

          days.push({
            title,
            subtitle: '',
            price1: `${price}:-`,
            price,
            marked: (this.daysRemote[i].special_text ? (price ? true : false) : false),
            value: i,
            pool_lid: day.pool_lid,
          });

          if (this.SITE_CONFIG.site === 'branas' && i === '7.1') {
            specialSeparator = false;
          }
        }
        /* eslint-ensable */

        return days;
      }

      return this.daysOriginal;
    },
    filtered() {
      return this.allProducts.filter((product) => {
        const selectedCategory = this.selectedSubCategory || this.selectedCategory;
        return (
          (!this.selectedAge || product.age === this.selectedAge)
          &&
          (!selectedCategory || product.categories.find(
            category => selectedCategory === category.slug,
          ))
          &&
          (!this.selectedType || product.type === this.selectedType)
        );
      });
    },
    categories() {
      const cats = {};

      this.allProducts.forEach((product) => {
        product.categories.forEach((category) => {
          cats[category.slug] = Object.assign({}, category);
          if (category.parent) {
            cats[category.parent.slug] = Object.assign({}, category.parent);
          }
        });
      });

      return cats;
    },
    subCategories() {
      const cats = {};

      this.allProducts.forEach((product) => {
        product.categories.forEach((category) => {
          if (category.parent) {
            cats[category.slug] = Object.assign({}, category);
          }
        });
      });

      return cats;
    },
    validStartDate() {
      return validStartDate({
        validStartDates: this.validStartDates,
      });
    },
  },
  methods: {
    ...mapMutations([
      'openModal',
      'updateRentalPerson',
      'updateSkiPassPerson',
      'closeModal',
    ]),
    async remount() {
      const person = this.$store.state.cart.skipasses.filter(skipass => skipass.type !== 'SKIPASS-ACCO')[this.$route.params.person];

      const { data, keycard, titles, asterisks }  = await API.frontendHelper(`skipass/list?only-season=${this.$route.query.onlyseason}`, {
        cart: this.$store.state.cart,
      });

      this.daysRemote = data;
      this.keycardObject = keycard;
      this.titles = titles;
      this.asterisks = asterisks;

      if (this.keycardObject && this.keycardObject.price > 0) {
        const price = Math.round(this.keycardObject.price, 10);
        this.products.buy.title = `Köp nytt liftkort (${price}:-)`;
      }

      // if (['vallasen', 'ulricehamn', 'storstenshojden', 'tolvmannabacken'].indexOf(this.SITE_CONFIG.site) !== -1) {
      //   this.products.buy.title = 'Gå vidare';
      // }

      this.name = person.name;
      this.loading = true;
      this.setAge(person.age);

      this.mountedDateLogic();
      this.loading = false;
    },
    changedDate(v, a) {
      this.selectedDays = v;
      this.update();
    },
    setType(t) {
      if (t === 'buy') {
        this.refill = false;

        if (this.keycardObject) {
          this.keycard = Math.round(parseFloat(this.keycardObject.price)) || 0;
        } else {
          this.keycard;
        }

        let content = 'Du hämtar kortet i infocentret.';

        if (this.has('accomodations', true) || this.has('rentals', true) || (this.$store.state.cart.addToOrder && this.$store.state.cart.addToOrder.number)) {
          content = 'Liftkortet ligger i ditt välkomstkuvert vid ankomst.';
        }

        if (['vallasen', 'ulricehamn', 'storstenshojden', 'tolvmannabacken'].indexOf(this.SITE_CONFIG.site) !== -1) {
          this.next();
        } else if (moment().isSameOrBefore(moment(this.SITE_CONFIG.skipass.season_campaign_end))) {
          this.next();
        } else {
          this.next();
        }
      } else {
        const $this = this;
        this.openModal(['SkiPassRefill', {
          onSetNumber: (prefix, number) => {
            $this.keycardNumberPrefix = prefix;
            $this.keycardNumber = number;
            $this.refill = true;
            $this.keycard = null;
            $this.next();
          },
        }]);
      }
    },
    mountedDateLogic() {
      let days = null;
      const person = this.$store.state.cart.skipasses[this.$route.params.person];

      if (person.days) {
        days = person.days;
      } else {
        const accomodations = JSON.parse(JSON.stringify(this.$store.state.cart.accomodations));
        const confirmed = accomodations.filter(accomodation => accomodation.confirmed);

        const personBefore = this.$store.state.cart.skipasses[this.$route.params.person - 1];
        if (personBefore) {
          days = personBefore.days;
        } else if (confirmed.length) {
          // Set date
          const start = moment(confirmed[0].period.date_arrival);
          const enddate = moment(confirmed[0].period.date_departure);

          this.pickedStartDate = start.toDate();
          this.pickedEndDate = enddate.toDate();
          days = Math.min(6, moment(this.pickedEndDate).diff(this.pickedStartDate, 'days') + 1);
          if (days === 6) {
            days = '6-8';
          }

        }
      }

      if (days) {
        this.changedDate(this.days.find(day => day.value === days));
      }
    },
    setAge(value) {
      if (!this.loading) {
        if (this.selectedAge) {
          this.selectedAge = '';
        } else {
          this.selectedAge = value;

          this.mountedDateLogic();
        }
      } else {
        this.selectedAge = value;
      }
      this.update();
    },
    update(c) {
      const guideCompleted = c;
      const guideFullyCompleted = c;
      const completed = c;

      if (!this.selectedDays) {
        return;
      }

      this.updateSkiPassPerson({
        index: this.$route.params.person,
        age: this.selectedAge,
        days: (this.selectedDays ? this.selectedDays.value : 0),
        price: (this.selectedDays ? this.selectedDays.price : 0),
        refill: this.refill,
        keycardNumber: this.keycardNumber,
        keycardNumberPrefix: this.keycardNumberPrefix,
        guideCompleted,
        guideFullyCompleted,
        completed,
        keycard: (this.keycard || 0),
        title: this.selectedDays.title,
        poolLid: this.selectedDays.pool_lid,
      });
    },
    next() {
      this.update(true);
      this.closeModal();
      this.$router.push({
        name: 'ski pass overview',
        query: this.$route.query,
      });

      window.trackViewItem({
        title: 'Liftkort',
        lines: [{
          id:  (this.selectedDays ? this.selectedDays.pool_lid : 0),
          title: 'Liftkort',
          category: 'equipment',
          quantity: 1,
          price: (this.selectedDays ? this.selectedDays.price : 0),
        }],
      });
    },
    moment(string) {
      return moment(string);
    },
    has(what, confirmed) {
      if (!this.$store.state.cart[what]) {
        return false;
      }
      return this.$store.state.cart[what].filter(a => (confirmed ? a.confirmed : true)).length;
    },
  },
};
</script>

<style scoped lang="stylus">
@import '~@/global.styl'

.skipass-age-wrapper
  max-width: 410px;
  margin: 0 auto;

.content
  margin-bottom 20px
  margin-top 20px
  &.disabled
    disabled()
hr
  height 2px
  opacity 0.19
  background-color white
  max-width 447px

h1
  united-heavy()
  uppercase()
  color white
  font-size 20px

h2
  uppercase()
  font-family inherit
  color white
  font-size 11px
  font-weight bold
  margin-bottom 8px

affix()
  width 4em
  display flex
  align-items center
  justify-content center

.white-text
  border-radius 2px
  background-color #F0F6EC
  border solid 1px #d1e0c2
  padding 15px 27px
  max-width 400px
  b
    font-size 11px
    font-weight bold
    color #1c1c1c
    display block
    margin-bottom 5px
    uppercase()
    .icon
      margin-right 3px
      position relative
      top -1px
  p
    font-size 14px
    font-weight 300
    line-height 1.3
    color #262626
    margin 0
  &.small
    padding 10px 8px
    p
      font-size 11px
      color #1c1c1c

.flex
  display flex
  justify-content center
  .control
    margin-left 15px
    margin-right 15px
    .label
      color white
      uppercase()
      font-size 11px
      font-weight bold
      color #ffffff
      margin-bottom 5px
    .flexer
      display flex
      align-items center
      cursor default
      align-items stretch
      transition-ease()
      border-radius: 3px;
      border: solid 2px #bfd9e1;
      background-color: #fff;
      .input
        input()
        border 0
        border-radius 0
        background none
      .suffix
        affix()
        transition-ease()
        background-color: #fff;
        border-left border
      &.selected
        background-color: #5aa478;
        border-color: #c7dcb7;
        .input
          color white
          font-weight bold
        .suffix
          background-color: #e7f1df;
          cursor pointer
  .box
    border-radius 4px
    background-color #ffffff
    box-shadow 0 0 15px 0 rgba(0, 0, 0, 0.2)
    padding 20px 25px
    margin 10px
    width 240px
    margin-top 25px
    margin-bottom 25px
    position relative
    .banner
      position absolute
      top: 20px;
      right: -105px;
      transform rotate(39deg)
      font-family Interstate
      font-size 10px
      font-weight bold
      letter-spacing 0.3px
      text-align center
      color #004d73
      background-color rgba(191, 217, 225, 0.7)
      padding 6px
      uppercase()
      width 300px
      text-align: center
    h3
      text-align center
      united-heavy()
      uppercase()
      font-size 16px
    button
      margin-top 25px
    li
      list-style disc
      margin-bottom 10px
      font-size 14px
      font-weight 300
      list-style-image url(https://static.booking.branasgruppen.se/static/svg/punklista-check.svg)
    &.larger
      margin-top 10px
      margin-bottom 10px
      width 290px
      overflow hidden
      h3
        font-size 19px

.dropdown-wrapper
  input()
  background none
  padding 0
  border 0
  width auto
  display inline-block
  max-width: 100% !important
  min-width 300px !important
  +max-mobile()
    margin-top: 8px

.button
  margin 10px
  transition all 0.05s
  position relative
  padding 14px
  margin-top 0
  margin-bottom 10px
  +max-mobile()
    padding: 5px
    margin: 10px 6px 5px 6px
  &.wide
    font-size: 12px
    +max-mobile()
      padding: 8px 12px 8px 12px
      font-size: 11px
  &.has-description
    padding-top: 8px;
    padding-bottom: 7px;
    min-width: 115px;
    font-size: 12px
    margin-bottom: 20px
    &:last-child
      margin-bottom: 0px
    +max-mobile()
      min-width: 90px
    span
      display block
      font-size 11px
      font-weight 300
      line-height 1.09
      text-align center
      color #161616
      text-transform none
      margin-top: 3px
    &.checked
      span
        color white
  &.checked:hover
    background-color #d68605
    border-color rgba(255, 255, 255, 0.7)
  &.checked:after
    content ""
    position absolute
    top -6px
    right -6px
    height 14px
    width 14px
    background-image url(https://static.booking.branasgruppen.se/static/svg/circle-green-minus.svg)
    background-size cover
  &.checked:hover:after
    background-image url(https://static.booking.branasgruppen.se/static/svg/circle-orange-minus.svg)

.language-switcher
  position absolute
  right 10px
  top 20px
  width: auto
  display inline-block
  padding: 5px 10px;


</style>



// WEBPACK FOOTER //
// SkiPassUser.vue?a2dc0f5e